import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
} from "antd";

import React, { useState } from "react";
import { vendors } from "../../data";

import { TbCurrencyDollar } from "react-icons/tb";
import { RiCloseCircleLine, RiAddCircleFill } from "react-icons/ri";
import TreeMultiSelect from "../../../../../../components/common/TreeSelect";
import { glAccounts } from "../../../../../../data/accounting";

import "./CreateBill.css";

function CreateBill({ workOrderNumber, isModalOpen, data, setIsModalOpen }) {
  const [checked, setChecked] = useState(false);
  const [value, setValue] = useState("");
  const [labors, setLabors] = useState([
    {
      maintenanceTech: "",
      date: "",
      amount: "",
      description: "",
    },
  ]);

  const [billItems, setBillItems] = useState([
    {
      quantity: "",
      account: "",
      statementDescription: "",
      rate: "",
      total: "",
    },
  ]);

  const [supplies, setSupplies] = useState([
    {
      quantity: "",
      itemType: "",
      account: "",
      salePrice: "",
      total: "",
    },
  ]);

  const addAnotherSupply = () => {
    setSupplies([
      ...supplies,
      {
        quantity: "",
        itemType: "",
        account: "",
        salePrice: "",
        total: "",
      },
    ]);
  };

  const OnRemoveSupply = (index) => {
    const newSupply = [...supplies];
    newSupply.splice(index, 1);
    setSupplies(newSupply);
  };

  const addAnotherBillItem = () => {
    setBillItems([
      ...billItems,
      {
        quantity: "",
        account: "",
        statementDescription: "",
        rate: "",
        total: "",
      },
    ]);
  };

  const onRemoveBillItem = (index) => {
    const newBillItem = [...billItems];
    newBillItem.splice(index, 1);
    setBillItems(newBillItem);
  };

  const addAnotherLabor = () => {
    setLabors([
      ...labors,
      {
        maintenanceTech: "",
        date: "",
        amount: "",
        description: "",
      },
    ]);
  };

  const onRemoveLabor = (index) => {
    const newlabor = [...labors];
    newlabor.splice(index, 1);
    setLabors(newlabor);
  };

  const onChange = (value) => {
    setValue(value);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <Modal open={isModalOpen} onCancel={handleCancel} className="create-bill" footer={null}>
      <h2>Create Bill for Work Order #{workOrderNumber}</h2>
      <Form layout="vertical">
        <Row className="work-order-content" gutter={[0, 16]}>
          <Col span={24} className="col-container">
            <p>Vendor</p>
            <Form.Item>
              <Select
                options={vendors}
                placeholder="Type to Search"
                allowClear
                showSearch
                onChange={onChange}
              />
            </Form.Item>
            {value !== "" ? (
              <Row gutter={[24, 0]}>
                <Col span={12} className="vendor-details">
                  <Row gutter={[0, 8]}>
                    <Col span={24}>
                      <p className="title">VENDOR</p>
                      <span className="onclick-text">{data?.vendor}</span>
                    </Col>
                    <Col span={24}>
                      <p>
                        <strong>Mobile:</strong>{" "}
                        <span className="onclick-text">{data?.mobile}</span>{" "}
                      </p>
                    </Col>
                    <Col span={24}>
                      <p>
                        <strong>Email:</strong>{" "}
                        <span className="onclick-text">{data?.email}</span>{" "}
                      </p>
                    </Col>
                    <Col span={24}>
                      <p>
                        {" "}
                        <span>{data?.address}</span>{" "}
                      </p>
                    </Col>
                    <Col span={24}>
                      <p className="onclick-text"> Remove </p>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Form.Item>
                    <p className="title">Work Order Adjustments</p>
                  </Form.Item>
                  <Form.Item label="Adjustment Percent" required>
                    <Input placeholder="Percent" />
                  </Form.Item>
                  <Form.Item label="Adjustment Type">
                    <Select
                      options={[{ value: "Discount" }, { value: "Markup" }]}
                      defaultValue="Discount"
                    />
                  </Form.Item>
                </Col>
              </Row>
            ) : null}
          </Col>
          <Col span={24} className="col-container">
            <p>Property</p>
            <p>test 2 -</p>
          </Col>
          <Col span={24} className="col-container">
            <p>Labor</p>
            <Row>
              <Col className="header-col" span={10}>
                <span>Maintenance Tech</span>
              </Col>
              <Col className="header-col" span={3}>
                <span>Date</span>
              </Col>
              <Col className="header-col" span={3}>
                <span>Hours</span>
              </Col>
              <Col className="header-col" span={7}>
                <span>Description</span>
              </Col>
            </Row>
            {labors.map((item, index) => {
              return (
                <Row align="middle" gutter={[8, 0]} key={index}>
                  <Col span={10}>
                    <Form.Item>
                      <Select
                        options={vendors}
                        defaultValue="aamir"
                        placeholder="Start typing to search"
                        allowClear
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item>
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    <Form.Item>
                      <RiCloseCircleLine
                        className="onclick-red-text"
                        size={22}
                        onClick={() => onRemoveLabor(index)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              );
            })}
            <Row>
              <Col span={24}>
                <button
                  className="add-icon-btn"
                  onClick={() => addAnotherLabor()}
                >
                  <RiAddCircleFill />
                  <span>Add Another Line</span>
                </button>
              </Col>
            </Row>
          </Col>
          <Col span={24} className="col-container">
            <p>Withheld Amount from Owner</p>
            <p>--</p>
          </Col>
          <Col span={24} className="col-container">
            <p>Parts And Supplies</p>
            <Row>
              <Col span={3}>
                <span>Qty</span>
              </Col>
              <Col span={6}>
                <span>Item Type</span>
              </Col>
              <Col span={6}>
                <span>Account</span>
              </Col>
              <Col span={4}>
                <span>Sale Price</span>
              </Col>
              <Col span={4}>
                <span>Total</span>
              </Col>
            </Row>
            {supplies.map((item, index) => {
              return (
                <Row gutter={[8, 0]} key={index}>
                  <Col span={3}>
                    <Form.Item>
                      <Input placeholder="Quantity" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item>
                      <Select
                        placeholder="Start typing to search"
                        showSearch
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item>
                      <TreeMultiSelect
                        options={glAccounts}
                        placeholder="Select"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item>
                      <InputNumber
                        addonBefore={<TbCurrencyDollar size={16} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item>
                      <InputNumber
                        addonBefore={<TbCurrencyDollar size={16} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    <Form.Item>
                      <RiCloseCircleLine
                        size={18}
                        className="onclick-red-text"
                        onClick={() => OnRemoveSupply(index)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              );
            })}
            <Row>
              <Col span={24}>
                <button
                  className="add-icon-btn"
                  onClick={() => addAnotherSupply()}
                >
                  <RiAddCircleFill />
                  <span>Add Another Line</span>
                </button>
              </Col>
            </Row>
          </Col>
          <Col span={24} className="col-container">
            <p>Billable Items</p>
            <Row>
              <Col className="header-col" span={4}>
                <span>Qty</span>
              </Col>
              <Col className="header-col" span={6}>
                <span>Account</span>
              </Col>
              <Col className="header-col" span={6}>
                <span>Statement Description</span>
              </Col>
              <Col className="header-col" span={4}>
                <span>Rate</span>
              </Col>
              <Col className="header-col" span={3}>
                <span>Total</span>
              </Col>
            </Row>
            {billItems.map((item, index) => {
              return (
                <Row gutter={[8, 0]} key={index}>
                  <Col span={4}>
                    <Form.Item>
                      <Input placeholder="Quantity" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item>
                      <TreeMultiSelect
                        options={glAccounts}
                        placeholder="Select..."
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item>
                      <Input placeholder="Statement Description" />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item>
                      <InputNumber
                        addonBefore={<TbCurrencyDollar size={16} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    <Form.Item>
                      <RiCloseCircleLine
                        size={22}
                        className="onclick-red-text"
                        onClick={() => onRemoveBillItem(index)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              );
            })}
            <Row>
              <Col span={24}>
                <button
                  className="add-icon-btn"
                  onClick={() => addAnotherBillItem()}
                >
                  <RiAddCircleFill />
                  <span>Add Another Line</span>
                </button>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Form.Item label="Invoice">
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Add Attachments To Invoice">
              <Space direction="vertical">
                <Checkbox>image1.png(232 KB)</Checkbox>
                <Checkbox>image1.png(232 KB)</Checkbox>
                <Checkbox>image1.png(232 KB)</Checkbox>
              </Space>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <Space direction="vertical">
                <Checkbox> Mark this job done</Checkbox>
                <Checkbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                >
                  Charge resident when creating bill
                </Checkbox>
              </Space>
            </Form.Item>
          </Col>
          {checked ? (
            <Col span={24}>
              <Form.Item label="Chargeback GL Accoun">
                <TreeMultiSelect options={glAccounts} placeholder="Select..." />
              </Form.Item>
            </Col>
          ) : null}
          <Col span={24}>
            <p>Bill Dates</p>
            <Form.Item>
              <span>Dates will only be saved upon creating a bill.</span>
            </Form.Item>
            <Row gutter={[8, 0]}>
              <Col span={8}>
                <Form.Item label="Bill Date" required>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Due Date" required>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Posting Date" required>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="action-buttons">
          <Button type="primary">Save & Close</Button>
          <Button type="primary">Save & Create Bill</Button>
          <button className="cancel-btn" onClick={()=>handleCancel()}>Cancel</button>
        </div>
      </Form>
    </Modal>
  );
}

export default CreateBill;
